// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconBrowserwallet } from "../../../icons/full/build/icon-browserwallet.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const BrowserwalletIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconBrowserwallet.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  BrowserwalletIcon.displayName = 'BrowserwalletIcon';
}

export default BrowserwalletIcon;